// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";

function handleVGSField(field, setFocus, setError) {
  if (field !== undefined) {
    field.on("focus", (function (param) {
            setFocus(function (param) {
                  return true;
                });
            setError(function (param) {
                  return "";
                });
          }));
    return field.on("blur", (function (param) {
                  setFocus(function (param) {
                        return false;
                      });
                }));
  }
  
}

function getTokenizedData(data) {
  var dict = Utils$OrcaPaymentPage.getDictFromJson(data);
  var cardNumber = Utils$OrcaPaymentPage.getString(dict, "card_number", "");
  var cardExp = Utils$OrcaPaymentPage.getString(dict, "card_exp", "");
  var cardCvc = Utils$OrcaPaymentPage.getString(dict, "card_cvc", "");
  var match = CardUtils$OrcaPaymentPage.getExpiryDates(cardExp);
  return [
          cardNumber,
          match[0],
          match[1],
          cardCvc
        ];
}

function getErrorStr(fieldname, emptyOpt, localeString) {
  var empty = emptyOpt !== undefined ? emptyOpt : false;
  switch (fieldname) {
    case "card_cvc" :
        if (empty) {
          return localeString.cvcNumberEmptyText;
        } else {
          return localeString.inCompleteCVCErrorText;
        }
    case "card_exp" :
        if (empty) {
          return localeString.cardExpiryDateEmptyText;
        } else {
          return localeString.inValidExpiryErrorText;
        }
    case "card_number" :
        if (empty) {
          return localeString.cardNumberEmptyText;
        } else {
          return localeString.enterValidCardNumberErrorText;
        }
    default:
      return "";
  }
}

function submitUserError(message) {
  Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", message);
}

function isFieldEmpty(dict, fieldname) {
  return Utils$OrcaPaymentPage.getBool(Core__Option.getOr(Core__Option.flatMap(dict[fieldname], Core__JSON.Decode.object), {}), "isEmpty", true);
}

function vgsErrorHandler(dict, fieldname, isSubmitOpt, localeString) {
  var isSubmit = isSubmitOpt !== undefined ? isSubmitOpt : false;
  var emptyErr = getErrorStr(fieldname, true, localeString);
  var invalidErr = getErrorStr(fieldname, undefined, localeString);
  var dataDict = Core__Option.flatMap(dict[fieldname], Core__JSON.Decode.object);
  var getBoolFromDictOpt = function (optDict, key, fallback) {
    return Utils$OrcaPaymentPage.getBool(Core__Option.getOr(optDict, {}), key, fallback);
  };
  var isFocused = getBoolFromDictOpt(dataDict, "isFocused", false);
  var isEmpty = getBoolFromDictOpt(dataDict, "isEmpty", isSubmit);
  var isValid = getBoolFromDictOpt(dataDict, "isValid", !isSubmit);
  if (isFocused) {
    return "";
  } else if (isEmpty) {
    if (isSubmit) {
      return emptyErr;
    } else {
      return "";
    }
  } else if (isValid) {
    return "";
  } else {
    return invalidErr;
  }
}

export {
  handleVGSField ,
  getTokenizedData ,
  getErrorStr ,
  submitUserError ,
  isFieldEmpty ,
  vgsErrorHandler ,
}
/* Utils-OrcaPaymentPage Not a pure module */
